export default __webpack_public_path__ + "static/media/b2.15ed8357.jpg";